import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import moment from "moment";

import { app } from "js/namespaces";
import { getStaticUrl } from "js/config";
import { TermsOfUseAndRefundPolicy } from "../TermsOfUseAndRefundPolicy/TermsOfUseAndRefundPolicy";
import { useScreenSize } from "js/react/hooks/useScreenSize";

const FeaturesCard = styled.div<{ useNarrowFormat?: boolean }>`
    background: #f7fafc;
    border: 1px solid #dae9f0;
    border-radius: 2px;
    padding: 20px;
    width: 100%;
    max-width: ${({ useNarrowFormat }) => (useNarrowFormat ? "none" : "280px")};
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const FeatureItem = styled.div`
    display: flex;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
`;


const FeatureText = styled.span`
    flex: 1;
    font-family: "Source Sans Pro", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.25;
    color: #888888;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const CheckIcon = getStaticUrl("/images/billing/check-circle.svg");

export function PlanFeatures({ useNarrowFormat = false, isAnnual = false, isTrial = false }) {
    const { t } = useTranslation();
    const trialStartDate = moment().format("MMMM DD, YYYY");
    const trialEndDate = moment().add(14, "days").format("MMMM DD, YYYY");
    const { isMobile } = useScreenSize();

    if (app.isMobileOrTablet || isMobile) {
        return null;
    }

    return (
        <FeaturesCard useNarrowFormat={useNarrowFormat}>
            {isTrial && <FeatureItem>
                <img src={CheckIcon} />
                <FeatureText>
                    {t("Enjoy a full 14 day free trial, from {{startDate}} to {{endDate}}", { startDate: trialStartDate, endDate: trialEndDate })}
                </FeatureText>
            </FeatureItem>}

            <FeatureItem>
                <img src={CheckIcon} />
                <FeatureText>
                    {t("Your subscription will renew automatically {{interval}}", { interval: t(isAnnual ? "annually" : "monthly") })}
                </FeatureText>
            </FeatureItem>

            {isTrial && <FeatureItem>
                <img src={CheckIcon} />
                <FeatureText>
                    {t("Cancel anytime before your trial ends, and you won't be charged")}
                </FeatureText>
            </FeatureItem>}
        </FeaturesCard>
    );
}
